import {
  ExpiredSessionMessages,
  TranslationExpiredSessionMessages
} from "../interfaces/expiredSessionMessages";

export const messages: TranslationExpiredSessionMessages = {
  [ExpiredSessionMessages.formDialogTitle]: "¡Su sesión ha caducado!",
  [ExpiredSessionMessages.formDialogContent]:
    "Reinicie con su usuario de inicio de sesión para continuar usando el sistema de manera segura",
  [ExpiredSessionMessages.formDialogActionText]:
    "Ir a la página de inicio de sesión"
};
